// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"84808ce4","283":"3b6d5537","324":"8d1d991a","453":"821fd3de","463":"dba136d7","713":"1e7e525b","773":"bdd394ab","780":"72ac5c23","831":"c46b2ba9","842":"8310f334"}[chunkId] + ".chunk.js";
};